import React, { Component } from 'react';
import './mainpage.css';
import logo from './logo.png';
import { Button } from '@fluentui/react-components';
import { 
  Navigation24Regular,
  MailFilled,
  SearchFilled,
  SearchInfoFilled,
  OrganizationFilled,
  PeopleFilled,
  ScalesFilled,
  ChevronDown24Regular,
  ChevronUp24Regular,
  DocumentPdf20Regular
} from '@fluentui/react-icons';
import NavBar from './NavBar';

interface KnowledgeProps {}

interface KnowledgeState {
  isMenuOpen: boolean;
  isProductsMenuOpen: boolean;
  isSolutionsMenuOpen: boolean;
  expandedSections: {
    pShareMail: boolean;
    docSearch: boolean;
    searchAssistant: boolean;
    pentities: boolean;
  };
  videoModalOpen: boolean;
}

class Knowledge extends Component<KnowledgeProps, KnowledgeState> {
  constructor(props: KnowledgeProps) {
    super(props);
    this.state = {
      isMenuOpen: false,
      isProductsMenuOpen: false,
      isSolutionsMenuOpen: false,
      expandedSections: {
        pShareMail: false,
        docSearch: false,
        searchAssistant: false,
        pentities: false
      },
      videoModalOpen: false
    };
  }

  toggleMenu = () => {
    this.setState({ isMenuOpen: !this.state.isMenuOpen });
  };

  toggleProductsMenu = () => {
    this.setState({ isProductsMenuOpen: !this.state.isProductsMenuOpen });
  };

  closeProductsMenu = () => {
    this.setState({ isProductsMenuOpen: false });
  };

  toggleSolutionsMenu = () => {
    this.setState({ isSolutionsMenuOpen: !this.state.isSolutionsMenuOpen });
  };

  closeSolutionsMenu = () => {
    this.setState({ isSolutionsMenuOpen: false });
  };

  toggleSection = (section: keyof KnowledgeState['expandedSections']) => {
    this.setState(prevState => ({
      expandedSections: {
        ...prevState.expandedSections,
        [section]: !prevState.expandedSections[section]
      }
    }));
  };

  render() {
    const { isMenuOpen, expandedSections } = this.state;

    return (
      <div className="main-page">
        {/* Top Navigation */}
        <NavBar />

        {/* Knowledge Base Content */}
        <section style={{ padding: '4rem 0', background: '#fff', minHeight: '70vh' }}>
          <div className="container">
            <div style={{ maxWidth: '900px', margin: '0 auto' }}>
              <h1 style={{ fontSize: '1.75rem', marginBottom: '1.5rem', color: '#111827', fontWeight: '700', textAlign: 'left' }}>
                Product Knowledge Base
              </h1>
              
              <p style={{ marginBottom: '2rem', color: '#374151', fontSize: '0.875rem', lineHeight: '1.6' }}>
                Explore detailed information about our four core products. Click on any product to expand and view more details.
              </p>

              {/* PShareMail Section */}
              <div style={{ marginBottom: '1rem', border: '1px solid #e5e7eb', borderRadius: '8px', overflow: 'hidden' }}>
                <div 
                  onClick={() => this.toggleSection('pShareMail')}
                  style={{ 
                    padding: '1.25rem', 
                    background: '#f9fafb', 
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    transition: 'background 0.2s'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.background = '#f3f4f6'}
                  onMouseLeave={(e) => e.currentTarget.style.background = '#f9fafb'}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                    <MailFilled style={{ fontSize: '1.5rem', color: '#2563eb' }} />
                    <h2 style={{ fontSize: '1.25rem', color: '#111827', fontWeight: '600', margin: 0 }}>
                      PShareMail
                    </h2>
                  </div>
                  {expandedSections.pShareMail ? <ChevronUp24Regular /> : <ChevronDown24Regular />}
                </div>
                {expandedSections.pShareMail && (
                  <div style={{ padding: '1.5rem', lineHeight: '1.6', color: '#374151', fontSize: '0.875rem' }}>
                    <p style={{ marginBottom: '1rem' }}>
                        <a href='/pShareEmailSupport.pdf' target='_blank' rel='noopener noreferrer' style={{ marginLeft: '1rem', fontSize: '0.875rem', color: '#2563eb', textDecoration: 'underline', display: 'inline-flex', alignItems: 'center', gap: '0.5rem' }}>
                          <DocumentPdf20Regular style={{ color: '#dc2626' }} />
                          pShareEmail Support Guide
                        </a>
                    </p>
                    {/* Additional content sections for PShareMail will go here */}
                  </div>
                )}
              </div>

              {/* DocSearch Section */}
              <div style={{ marginBottom: '1rem', border: '1px solid #e5e7eb', borderRadius: '8px', overflow: 'hidden' }}>
                <div 
                  onClick={() => this.toggleSection('docSearch')}
                  style={{ 
                    padding: '1.25rem', 
                    background: '#f9fafb', 
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    transition: 'background 0.2s'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.background = '#f3f4f6'}
                  onMouseLeave={(e) => e.currentTarget.style.background = '#f9fafb'}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                    <SearchFilled style={{ fontSize: '1.5rem', color: '#2563eb' }} />
                    <h2 style={{ fontSize: '1.25rem', color: '#111827', fontWeight: '600', margin: 0 }}>
                      DocSearch
                    </h2>
                  </div>
                  {expandedSections.docSearch ? <ChevronUp24Regular /> : <ChevronDown24Regular />}
                </div>
                {expandedSections.docSearch && (
                  <div style={{ padding: '1.5rem', lineHeight: '1.6', color: '#374151', fontSize: '0.875rem' }}>
                    <p style={{ marginBottom: '1rem' }}>
                        <a href='/DocSearchManual.pdf' target='_blank' rel='noopener noreferrer' style={{ marginLeft: '1rem', fontSize: '0.875rem', color: '#2563eb', textDecoration: 'underline', display: 'inline-flex', alignItems: 'center', gap: '0.5rem' }}>
                          <DocumentPdf20Regular style={{ color: '#dc2626' }} />
                          DocSearch Manual
                        </a>
                    </p>
                    {/* Additional content sections for DocSearch will go here */}
                  </div>
                )}
              </div>

              {/* Search Assistant Section */}
              <div style={{ marginBottom: '1rem', border: '1px solid #e5e7eb', borderRadius: '8px', overflow: 'hidden' }}>
                <div 
                  onClick={() => this.toggleSection('searchAssistant')}
                  style={{ 
                    padding: '1.25rem', 
                    background: '#f9fafb', 
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    transition: 'background 0.2s'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.background = '#f3f4f6'}
                  onMouseLeave={(e) => e.currentTarget.style.background = '#f9fafb'}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                    <SearchInfoFilled style={{ fontSize: '1.5rem', color: '#2563eb' }} />
                    <h2 style={{ fontSize: '1.25rem', color: '#111827', fontWeight: '600', margin: 0 }}>
                      Search Assistant
                    </h2>
                  </div>
                  {expandedSections.searchAssistant ? <ChevronUp24Regular /> : <ChevronDown24Regular />}
                </div>
                {expandedSections.searchAssistant && (
                  <div style={{ padding: '1.5rem', lineHeight: '1.6', color: '#374151', fontSize: '0.875rem' }}>
                    <p style={{ marginBottom: '1rem' }}>
                        <a href='/SearchAssistantTeamsManual.pdf' target='_blank' rel='noopener noreferrer' style={{ marginLeft: '1rem', fontSize: '0.875rem', color: '#2563eb', textDecoration: 'underline', display: 'inline-flex', alignItems: 'center', gap: '0.5rem' }}>
                          <DocumentPdf20Regular style={{ color: '#dc2626' }} />
                          Search Assistant Teams Manual
                        </a>
                    </p>
                    {/* Additional content sections for Search Assistant will go here */}
                  </div>
                )}
              </div>

              {/* pEntities Section */}
              <div style={{ marginBottom: '1rem', border: '1px solid #e5e7eb', borderRadius: '8px', overflow: 'hidden' }}>
                <div 
                  onClick={() => this.toggleSection('pentities')}
                  style={{ 
                    padding: '1.25rem', 
                    background: '#f9fafb', 
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    transition: 'background 0.2s'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.background = '#f3f4f6'}
                  onMouseLeave={(e) => e.currentTarget.style.background = '#f9fafb'}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                    <OrganizationFilled style={{ fontSize: '1.5rem', color: '#2563eb' }} />
                    <h2 style={{ fontSize: '1.25rem', color: '#111827', fontWeight: '600', margin: 0 }}>
                      pEntities
                    </h2>
                  </div>
                  {expandedSections.pentities ? <ChevronUp24Regular /> : <ChevronDown24Regular />}
                </div>
                {expandedSections.pentities && (
                  <div style={{ padding: '1.5rem', lineHeight: '1.6', color: '#374151', fontSize: '0.875rem', textAlign: 'left' }}>
                    <p style={{ marginBottom: '1rem', textAlign: 'left' }}>
                        <a href='/pEntities-User-Manual.pdf' target='_blank' rel='noopener noreferrer' style={{ fontSize: '0.875rem', color: '#2563eb', textDecoration: 'underline', display: 'inline-flex', alignItems: 'center', gap: '0.5rem' }}>
                          <DocumentPdf20Regular style={{ color: '#dc2626' }} />
                          pEntities User Manual
                        </a>
                    </p>

                    {/* Video preview */}
                    <p style={{ marginTop: '1.25rem', marginBottom: '0.4rem', fontWeight: '600', color: '#111827', fontSize: '0.9rem', textAlign: 'left' }}>
                      Document Management in pEntities
                    </p>
                    <p style={{ marginBottom: '0.75rem', color: '#4b5563', fontSize: '0.825rem', maxWidth: '560px', lineHeight: '1.6', textAlign: 'left' }}>
                      See how pEntities, powered by Azure Document Intelligence, extracts structured data from invoices, contracts, identities, and more automatically mapping results to SharePoint fields or routing them to Power Automate flows and REST APIs, turning every document into actionable, searchable intelligence.
                    </p>
                    <div
                      onClick={() => this.setState({ videoModalOpen: true })}
                      style={{
                        position: 'relative',
                        display: 'block',
                        cursor: 'pointer',
                        borderRadius: '8px',
                        overflow: 'hidden',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                        marginTop: '0.5rem',
                        width: '320px'
                      }}
                      title="Watch Document Management in pEntities"
                    >
                      <img loading="lazy" decoding="async"
                        src="https://img.youtube.com/vi/CAi1nFE8qU0/hqdefault.jpg"
                        alt="pEntities video preview"
                        style={{ width: '100%', display: 'block' }}
                      />
                      {/* Play button overlay */}
                      <div style={{
                        position: 'absolute',
                        inset: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: 'rgba(0,0,0,0.25)',
                        transition: 'background 0.2s'
                      }}
                        onMouseEnter={(e) => (e.currentTarget.style.background = 'rgba(0,0,0,0.45)')}
                        onMouseLeave={(e) => (e.currentTarget.style.background = 'rgba(0,0,0,0.25)')}
                      >
                        <svg width="52" height="52" viewBox="0 0 68 48" xmlns="http://www.w3.org/2000/svg">
                          <path d="M66.5 7.7A8.5 8.5 0 0 0 60.7 2C55.4.4 34 .4 34 .4S12.6.4 7.3 2A8.5 8.5 0 0 0 1.5 7.7C0 13 0 24 0 24s0 11 1.5 16.3A8.5 8.5 0 0 0 7.3 46C12.6 47.6 34 47.6 34 47.6s21.4 0 26.7-1.6a8.5 8.5 0 0 0 5.8-5.7C68 35 68 24 68 24s0-11-1.5-16.3z" fill="#ff0000"/>
                          <path d="M27 34l18-10-18-10v20z" fill="#fff"/>
                        </svg>
                      </div>
                    </div>

                    {/* Video modal */}
                    {this.state.videoModalOpen && (
                      <div
                        onClick={() => this.setState({ videoModalOpen: false })}
                        style={{
                          position: 'fixed',
                          inset: 0,
                          background: 'rgba(0,0,0,0.75)',
                          zIndex: 1000,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        <div
                          onClick={(e) => e.stopPropagation()}
                          style={{
                            position: 'relative',
                            width: '95%',
                            maxWidth: '1200px',
                            aspectRatio: '16/9',
                            background: '#000',
                            borderRadius: '8px',
                            overflow: 'hidden'
                          }}
                        >
                          <button
                            onClick={() => this.setState({ videoModalOpen: false })}
                            style={{
                              position: 'absolute',
                              top: '8px',
                              right: '12px',
                              zIndex: 10,
                              background: 'rgba(0,0,0,0.6)',
                              border: 'none',
                              color: '#fff',
                              fontSize: '1.5rem',
                              lineHeight: 1,
                              cursor: 'pointer',
                              borderRadius: '50%',
                              width: '32px',
                              height: '32px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center'
                            }}
                            aria-label="Close video"
                          >
                            &times;
                          </button>
                          <iframe
                            width="100%"
                            height="100%"
                            src="https://www.youtube.com/embed/CAi1nFE8qU0?autoplay=1"
                            title="Document Management in pEntities"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            style={{ display: 'block' }}
                          />
                        </div>
                      </div>
                    )}

                  </div>
                )}
              </div>

            </div>
          </div>
        </section>

        {/* Footer */}
        <footer className="footer">
          <div className="container">
            <div className="footer-grid">
              <div className="footer-column">
                <h4>Products</h4>
                <ul>
                  <li><a href="/solutions/pentities">pEntities</a>
                    <ul className="footer-subnav">
                      <li><a href="/solutions/automation">Automation Module</a></li>
                      <li><a href="/solutions/ticketing">Ticketing Module</a></li>
                      <li><a href="/solutions/hr-template">HR Module</a></li>
                      <li><a href="/solutions/case-management">Legal Module</a></li>
                      <li><a href="/solutions/hr-hub">Employee Module</a></li>
                    </ul>
                  </li>
                  <li><a href="/solutions/pshareemail">PShareEmail</a></li>
                  <li><a href="/solutions/docsearch">DocSearch Tool</a></li>
                  <li><a href="/solutions/searchassistant">Search Assistant</a></li>
                </ul>
              </div>
              <div className="footer-column">
                <h4>Company</h4>
                <ul>
                  <li><a href="/about">About Us</a></li>
                  <li><a href="/get-started">Get Started</a></li>
                  <li><a href="/contactus">Contact Us</a></li>
                  <li><a href="/plans-pricing">Plans & Pricing</a></li>
                </ul>
              </div>
              <div className="footer-column">
                <h4>Support</h4>
                <ul>
                  <li><a href="/knowledge">Knowledge Base</a></li>
                  <li><a href="/technical-support">Technical Support</a></li>
                </ul>
              </div>
              <div className="footer-column">
                <h4>Contact Us</h4>
                <div className="footer-office">
                  <p className="office-name">Athens Office</p>
                  <p>365 Kifisias Avenue, Kifisia, 14561</p>
                  <p>Ground Floor, Inside the Arcade</p>
                  <p>Tel: (+30)-210-260-3764</p>
                </div>
                <div className="footer-office">
                  <p className="office-name">Thessaloniki Office</p>
                  <p>15 Nikiforou Ouranou & Minotavrou Streets</p>
                  <p>Thessaloniki, 54627, PORTO CENTER, Building G1, 3rd Floor</p>
                  <p>Tel: (+30)-231-005-3361</p>
                </div>
                <div className="footer-office">
                  <p className="office-name">Crete Office</p>
                  <p>Kisamos, Chania</p>
                  <p>Tel: (+30)-2822-051309</p>
                </div>
                <p className="footer-email">info@meta-365.com</p>
              </div>
            </div>
            <div className="footer-bottom">
              <p>&copy; 2026 Meta-365. All rights reserved.</p>
              <div className="footer-social">
                <a href="https://www.linkedin.com/company/meta-365" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><img loading="lazy" decoding="async" src="data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%20fill='white'%3E%3Cpath%20d='M4.98%203.5C4.98%204.88%203.87%206%202.5%206S0%204.88%200%203.5%201.12%201%202.5%201s2.48%201.12%202.48%202.5zM.25%208h4.5v13H.25V8zM8.5%208h4.31v1.78h.06c.6-1.14%202.07-2.34%204.26-2.34C21.5%207.44%2022.5%2010%2022.5%2014.02V21H18v-6.1c0-1.46-.03-3.33-2.03-3.33-2.03%200-2.34%201.58-2.34%203.22V21H8.5V8z'/%3E%3C/svg%3E" alt="LinkedIn" width="18" height="18" /></a>
                <a href="https://www.facebook.com/profile.php?id=61589941284929" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><img loading="lazy" decoding="async" src="data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%20fill='white'%3E%3Cpath%20d='M24%2012.07C24%205.4%2018.63%200%2012%200S0%205.4%200%2012.07C0%2018.1%204.39%2023.1%2010.13%2024v-8.44H7.08v-3.49h3.05V9.41c0-3.02%201.79-4.69%204.53-4.69%201.31%200%202.68.24%202.68.24v2.97h-1.51c-1.49%200-1.96.93-1.96%201.89v2.25h3.33l-.53%203.49h-2.8V24C19.61%2023.1%2024%2018.1%2024%2012.07z'/%3E%3C/svg%3E" alt="Facebook" width="18" height="18" /></a>
              </div>
              <div className="footer-links">
                <a href="/privacy-policy">Privacy Policy</a>
                <a href="/terms-of-use">Terms & Conditions</a>
              </div>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}

export default Knowledge;

